import { useQuery } from "@tanstack/react-query"
import { getSubscriptionStatus } from "../infrastructure/subscription.api"
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations"

export function useSubscriptionStatus(organizationId?: string) {
  const currentOrganization = useCurrentOrganization()
  // Callers that don't pass an id mean "the active organisation".
  const orgId = organizationId ?? currentOrganization?.id

  return useQuery({
    queryKey: ["subscription", "status", orgId],
    queryFn: () => getSubscriptionStatus(orgId),
    // The endpoint requires an organisation id; firing without one hits the API
    // with an empty org and 404s. Wait until we actually have an org.
    enabled: !!orgId,
  })
}
